// extracted by mini-css-extract-plugin
export default {"root":"PrintMultiPreviewLayout_root__pWCtw","colClientInfo":"PrintMultiPreviewLayout_colClientInfo__DDY23"};